module.exports = __webpack_public_path__ + "img/man-torso-back.db04d1dc.png";